import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import toast from "react-hot-toast";
import Box from '../../components/Box';
import { MenuComponent } from '../../_metronic/assets/ts/components';
import { KTCard } from '../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../_metronic/helpers/components/KTCardBody';
import Content from '../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../_metronic/layout/core';
import { ToolbarWrapper } from '../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../redux/reducers/authSlice';
import { RootState } from '../../redux/store';
import RefreshButton from '../../components/RefreshButton';
import ColumnChooser from '../../components/ColumnChooser';
import TableConstantActions from '../../components/TableConstantActions';
import CustomTextInput from '../../components/CustomTextInput';
import CustomSwitch from '../../components/CustomSwitch';
import { ColumnChooserModel } from '../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../models/common/ColumnFilterModel';
import { kolonlariBirlestir } from '../../components/ColumnFilter/kolonBirlestir';
import ColumnFilterRow from '../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, foldText } from '../../components/ColumnFilter/ColumnFilterTypes';
import { useSortableColumns } from '../../helpers/useSortableColumns';
import { VardiyaMolasi, VardiyaService, VardiyaTanimiItem } from '../../services/VardiyaService';
import { calismaDk, saatMetni, vardiyaRengi } from '../../helpers/vardiyaDesen';

const EVET_HAYIR = [{ value: '1', label: 'Evet' }, { value: '0', label: 'Hayır' }];
const SAAT = /^([01]\d|2[0-3]):[0-5]\d$/;
const MOLA_EN_FAZLA = 8;

/** Mola grid satırı (değişiklikler formdaki Kaydet'e kadar yereldir; Çalışma Saatleri kalıbı). */
interface MolaSatiri extends VardiyaMolasi {
    anahtar: string
    isSelected: boolean
}

let molaSayaci = 0;
const molaAnahtari = () => 'vmola-' + (molaSayaci++);

/** Ekranda süzme / sıralama için satırın kolon değeri. */
const kolonDegeri = (x: VardiyaTanimiItem, kolon: string): string => {
    switch (kolon) {
        case 'kod': return x.kod;
        case 'ad': return x.ad;
        case 'saat': return x.baslangic;
        case 'ara': return x.araBaslangic ?? '';
        case 'calismaDk': return String(x.calismaDk).padStart(5, '0');
        case 'geceVardiyasi': return x.geceVardiyasi ? '1' : '0';
        case 'bildirim': return x.bildirimDk == null ? '' : String(x.bildirimDk).padStart(4, '0');
        case 'aktif': return x.aktif ? '1' : '0';
        case 'kullanimSayisi': return String(x.kullanimSayisi).padStart(6, '0');
        default: return '';
    }
}

interface EkranFiltresi {
    sortColumn?: string
    sortDirection?: string
    columnFilters: ColumnFilterModel[]
}

/**
 * Vardiya Tanımları (İnsan Kaynakları > Tanımlamalar, Faz 2, 03.11.2026). Kod çizelgede ve puantajda yazar (S, AK, G).
 * Bitiş başlangıçtan önceyse vardiya ertesi gün biter (22:00–06:00); kayıt başladığı güne yazılır.
 * Bildirim / hatırlatma boşsa Çalışma Saatleri'ndeki değer kullanılır. Kısa liste: üstte açılan form (İzin Türleri kalıbı).
 */
const VardiyaTanimiList = () => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "İnsan Kaynakları > Tanımlamalar > Vardiya Tanımları"
    const pageVersion = "1";
    const menu = auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName);
    const formRef = useRef<any>(null);

    const [liste, setListe] = useState<VardiyaTanimiItem[]>([]);
    const [filter, setFilter] = useState<EkranFiltresi>({ sortColumn: undefined, sortDirection: 'asc', columnFilters: [] });

    const [isOpen, setIsOpen] = useState(false);
    const [duzenlenenId, setDuzenlenenId] = useState<string | undefined>(undefined);
    const [kod, setKod] = useState<string | undefined>(undefined);
    const [ad, setAd] = useState<string | undefined>(undefined);
    const [bas, setBas] = useState<string | undefined>(undefined);
    const [bit, setBit] = useState<string | undefined>(undefined);
    const [molalar, setMolalar] = useState<MolaSatiri[]>([]);
    const [molaFormu, setMolaFormu] = useState(false);
    const [molaGuncellenen, setMolaGuncellenen] = useState<string | undefined>(undefined);
    const [molaAd, setMolaAd] = useState<string | undefined>(undefined);
    const [molaBas, setMolaBas] = useState<string>('');
    const [molaBit, setMolaBit] = useState<string>('');
    const [bildirim, setBildirim] = useState<string | undefined>(undefined);
    const [hatirlatma, setHatirlatma] = useState<string | undefined>(undefined);
    const [aktif, setAktif] = useState<boolean>(true);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Kod', name: 'kod', order: 0, isVisible: true },
            { title: 'Ad', name: 'ad', order: 0, isVisible: true },
            { title: 'Saat', name: 'saat', order: 0, isVisible: true },
            { title: 'Ara / Molalar', name: 'ara', order: 0, isVisible: true },
            { title: 'Süre', name: 'calismaDk', order: 0, isVisible: true },
            { title: 'Gece', name: 'geceVardiyasi', order: 0, isVisible: true },
            { title: 'Bildirim / Tekrar (dk)', name: 'bildirim', order: 0, isVisible: true },
            { title: 'Aktif', name: 'aktif', order: 0, isVisible: true },
            { title: 'Kullanım', name: 'kullanimSayisi', order: 0, isVisible: true },
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
        getData();
    }, [])

    const getData = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await VardiyaService.tanimListesi();

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                return;
            }

            setListe((response.data ?? []).map(x => ({ ...x, isSelected: false })));
        } catch (error: any) {
            toast.error(error);
        } finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const gorunen = liste.filter(x => (filter.columnFilters ?? []).every(f => {
        if (f.values && f.values.length > 0)
            return f.values.includes(kolonDegeri(x, f.column));

        if (f.text && f.text.trim())
            return foldText(kolonDegeri(x, f.column)).includes(foldText(f.text.trim()));

        return true;
    })).sort((a, b) => {
        if (!filter.sortColumn)
            return 0;

        var r = kolonDegeri(a, filter.sortColumn).localeCompare(kolonDegeri(b, filter.sortColumn), 'tr');
        return filter.sortDirection == 'desc' ? -r : r;
    });

    const sortableColumns = ['kod', 'ad', 'saat', 'calismaDk', 'geceVardiyasi', 'bildirim', 'aktif', 'kullanimSayisi'];
    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, (f?: EkranFiltresi) => { if (f) setFilter(f); });

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        kod: { type: 'text' },
        ad: { type: 'text' },
        geceVardiyasi: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
        aktif: { type: 'select', allowEmpty: false, loadOptions: () => Promise.resolve(EVET_HAYIR) },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => setFilter({ ...filter, columnFilters });

    const setItemSelected = (_id: string) => setListe(liste.map(x => x.vardiyaTanimiId == _id ? { ...x, isSelected: !x.isSelected } : x));

    const selectAll = () => {
        var ids = gorunen.map(x => x.vardiyaTanimiId);
        var isAllSelected = gorunen.length > 0 && gorunen.every(x => x.isSelected);
        setListe(liste.map(x => ids.includes(x.vardiyaTanimiId) ? { ...x, isSelected: !isAllSelected } : x));
    }

    const secililer = liste.filter(x => x.isSelected);
    const kodlar = liste.map(x => x.kod);

    const scrollTo = () => setTimeout(() => formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 50);

    const formuDoldur = (o: VardiyaTanimiItem | undefined) => {
        setDuzenlenenId(o?.vardiyaTanimiId);
        setKod(o?.kod);
        setAd(o?.ad);
        setBas(o?.baslangic);
        setBit(o?.bitis);
        // Eski kayıtta ayrı tutulan ara, molalar tablosuna "Ara" satırı olarak gelir; kaydedince oraya taşınır.
        const eskiAra: VardiyaMolasi[] = o?.araBaslangic && o?.araBitis ? [{ ad: 'Ara', baslangic: o.araBaslangic, bitis: o.araBitis }] : [];
        setMolalar([...eskiAra, ...(o?.molalar ?? [])].map(m => ({ ...m, anahtar: molaAnahtari(), isSelected: false })));
        molaFormuKapat();
        setBildirim(o?.bildirimDk == null ? undefined : String(o.bildirimDk));
        setHatirlatma(o?.hatirlatmaDk == null ? undefined : String(o.hatirlatmaDk));
        setAktif(o?.aktif ?? true);
    }

    // ---------------------------------------------------------------- Molalar (Çalışma Saatleri kalıbı)

    const molaFormuKapat = () => { setMolaFormu(false); setMolaGuncellenen(undefined); setMolaAd(undefined); setMolaBas(''); setMolaBit(''); }

    const molaEkleIptal = () => {
        if (molaFormu) { molaFormuKapat(); return; }
        if (molalar.length >= MOLA_EN_FAZLA) { toast.error(`En çok ${MOLA_EN_FAZLA} mola girilebilir.`); return; }
        setMolaFormu(true);
    }

    const molaGuncelleAc = () => {
        const m = molalar.find(x => x.isSelected);
        if (!m) return;
        setMolaGuncellenen(m.anahtar); setMolaAd(m.ad ?? undefined); setMolaBas(m.baslangic); setMolaBit(m.bitis); setMolaFormu(true);
    }

    const molaKaydet = () => {
        if (!molaAd || molaAd.trim() == '') { toast.error('Mola adı zorunludur (ör. Öğle arası, Sabah çayı).'); return; }
        if (!SAAT.test(molaBas) || !SAAT.test(molaBit) || molaBas == molaBit) { toast.error('Molanın başlangıç ve bitişini giriniz.'); return; }
        const yeni = { ad: molaAd.trim(), baslangic: molaBas, bitis: molaBit };
        setMolalar(molaGuncellenen
            ? molalar.map(x => x.anahtar == molaGuncellenen ? { ...x, ...yeni, isSelected: false } : x)
            : [...molalar, { ...yeni, anahtar: molaAnahtari(), isSelected: false }]);
        molaFormuKapat();
    }

    const molaSeciliSayisi = molalar.filter(x => x.isSelected).length;
    const molaSecimi = (anahtar: string) => setMolalar(molalar.map(x => x.anahtar == anahtar ? { ...x, isSelected: !x.isSelected } : x));
    const molaTumunuSec = () => { const hepsi = molaSeciliSayisi > 0 && molaSeciliSayisi == molalar.length; setMolalar(molalar.map(x => ({ ...x, isSelected: !hepsi }))); }
    const molaSil = () => { setMolalar(molalar.filter(x => !x.isSelected)); molaFormuKapat(); }

    const yeniEkle = () => { formuDoldur(undefined); setIsOpen(true); scrollTo(); }
    const iptalEt = () => { formuDoldur(undefined); setIsOpen(false); }

    const ac = (o: VardiyaTanimiItem | undefined) => {
        if (!o || !menu?.canUpdate)
            return;
        formuDoldur(o);
        setIsOpen(true);
        scrollTo();
    }

    const sayi = (s: string | undefined) => s && s.trim() != '' ? Number(s) : null;

    /** Formdaki saatlerden süre önizlemesi (geçersizse null). */
    const onizleme = (() => {
        if (!bas || !bit || !SAAT.test(bas) || !SAAT.test(bit) || bas == bit)
            return null;
        return { dk: calismaDk(bas, bit, null, null, molalar.map(m => m.baslangic + '-' + m.bitis)), gece: bit <= bas };
    })();

    const kaydet = async () => {
        try {
            if (!kod || kod.trim() == '') { toast.error("Kod alanı zorunludur."); return; }
            if (!ad || ad.trim() == '') { toast.error("Ad alanı zorunludur."); return; }
            if (!bas || !SAAT.test(bas) || !bit || !SAAT.test(bit)) { toast.error("Başlangıç ve bitişi SS:dd biçiminde giriniz."); return; }


            var b = sayi(bildirim), h = sayi(hatirlatma);
            if ((b != null && (isNaN(b) || b < 0)) || (h != null && (isNaN(h) || h < 0))) {
                toast.error("Bildirim ve tekrar dakikası geçerli değil.");
                return;
            }

            dispatch(storeActivityIndicator(true));

            var response = await VardiyaService.tanimKaydet({
                vardiyaTanimiId: duzenlenenId ?? null,
                kod: kod.trim(),
                ad: ad.trim(),
                baslangic: bas,
                bitis: bit,
                araBaslangic: null,
                araBitis: null,
                molalar: molalar.map(m => ({ ad: m.ad, baslangic: m.baslangic, bitis: m.bitis })),
                bildirimDk: b,
                hatirlatmaDk: h,
                aktif
            });

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success(response.data?.uyari ? "Vardiya kaydedildi. Uyarı: " + response.data.uyari : "Vardiya kaydedildi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const sil = async () => {
        try {
            dispatch(storeActivityIndicator(true));
            var response = await VardiyaService.tanimSil(secililer.map(x => x.vardiyaTanimiId));

            if (!response.isSuccess) {
                toast.error(response.message ?? '');
                dispatch(storeActivityIndicator(false));
                return;
            }

            toast.success("Seçilen vardiyalar silindi.");
            iptalEt();
            await getData();
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    const hucre = (item: VardiyaTanimiItem, column: string) => {
        var icerik: React.ReactNode;

        if (column == 'kod')
            icerik = <span className='badge ebbe-status-badge' style={vardiyaRengi(item.kod, kodlar)}>{item.kod}</span>;
        else if (column == 'ad')
            icerik = item.ad;
        else if (column == 'saat')
            icerik = <React.Fragment>{item.baslangic}–{item.bitis}{item.geceYarisiniGecer && <span className='text-muted fs-8'> (ertesi gün)</span>}</React.Fragment>;
        else if (column == 'ara')
            icerik = <React.Fragment>
                {item.araBaslangic && <div>Ara {item.araBaslangic}–{item.araBitis}</div>}
                {(item.molalar ?? []).map((m, i) => <div key={i} className='fs-8'>{m.ad ? m.ad + ' ' : ''}{m.baslangic}–{m.bitis}</div>)}
            </React.Fragment>;
        else if (column == 'calismaDk')
            icerik = <React.Fragment>{saatMetni(item.calismaDk)}{item.uyari && <div className='text-danger fs-8'>{item.uyari}</div>}</React.Fragment>;
        else if (column == 'geceVardiyasi')
            icerik = item.geceVardiyasi ? 'Evet' : 'Hayır';
        else if (column == 'bildirim')
            icerik = item.bildirimDk == null && item.hatirlatmaDk == null
                ? <span className='text-muted fs-8'>Çalışma Saatleri</span>
                : `${item.bildirimDk ?? '–'} / ${item.hatirlatmaDk ?? '–'}`;
        else if (column == 'aktif')
            icerik = <span className={'badge ebbe-status-badge ' + (item.aktif ? 'badge-light-primary' : 'badge-light')}>{item.aktif ? 'Aktif' : 'Pasif'}</span>;
        else if (column == 'kullanimSayisi')
            icerik = item.kullanimSayisi;

        return <td key={column} onClick={() => setItemSelected(item.vardiyaTanimiId)} onDoubleClick={() => ac(item)}>{icerik}</td>;
    }

    const gorunenKolonlar = columns.filter(x => x.isVisible).sort((a, b) => a.order - b.order);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <TableConstantActions
                    deleteFunction={sil}
                    onSearchSubmit={(e) => e.preventDefault()}
                    pageName={pageName}
                    hideSearch={true}
                    searchTerm=''
                    selectedCount={secililer.length}
                    setSearchTerm={() => { }}
                    updateFunction={() => ac(secililer[0])}
                />

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                {
                    menu?.canInsert && (
                        <div className='m-0'>
                            <a onClick={yeniEkle} className='btn btn-sm fw-bold btn-primary'>Yeni Vardiya Ekle</a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                {
                    isOpen && (
                        <div ref={formRef}>
                            <KTCard className='ebbe-card mb-3'>
                                <KTCardBody>
                                    <h4 className="mb-10 text-black">{duzenlenenId ? 'Vardiyayı Güncelle' : 'Yeni Vardiya'}</h4>

                                    <div className="row">
                                        <div className="col-md-2">
                                            <CustomTextInput labelText="Kod" isLabelRequired value={kod} setValue={setKod} placeholder="S" />
                                        </div>
                                        <div className="col-md-3">
                                            <CustomTextInput labelText="Ad" isLabelRequired value={ad} setValue={setAd} placeholder="Sabah" />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label required">Başlangıç</label>
                                            <input type="time" className="form-control form-control-solid" style={{ border: '1px solid #F1F1F4' }} value={bas ?? ''} onChange={(e) => setBas(e.target.value)} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label required">Bitiş</label>
                                            <input type="time" className="form-control form-control-solid" style={{ border: '1px solid #F1F1F4' }} value={bit ?? ''} onChange={(e) => setBit(e.target.value)} />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">Aktif</label>
                                            <CustomSwitch isActive={aktif} setIsActive={setAktif} />
                                        </div>
                                    </div>

                                    <div className="row mt-5">
                                        <div className="col-md-2">
                                            <CustomTextInput labelText="Bildirim (dk önce/sonra)" value={bildirim} setValue={setBildirim} />
                                        </div>
                                        <div className="col-md-2">
                                            <CustomTextInput labelText="Tekrar (dk)" value={hatirlatma} setValue={setHatirlatma} />
                                        </div>
                                    </div>

                                    <Box className='ebbe-hr m-0 mt-8'>&nbsp;</Box>
                                    <h5 className="mt-5 mb-5 text-black">Ara ve Molalar</h5>

                                    {
                                        molaFormu && (
                                            <React.Fragment>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <CustomTextInput labelText="Ad" isLabelRequired placeholder="Örn. Öğle arası, Sabah çayı" value={molaAd} setValue={setMolaAd} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label required">Başlangıç</label>
                                                        <input type="time" className="form-control form-control-solid" style={{ border: '1px solid #F1F1F4' }} value={molaBas} onChange={(e) => setMolaBas(e.target.value)} />
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label className="form-label required">Bitiş</label>
                                                        <input type="time" className="form-control form-control-solid" style={{ border: '1px solid #F1F1F4' }} value={molaBit} onChange={(e) => setMolaBit(e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="row mt-5">
                                                    <div className="col-md-12">
                                                        <Box alignItems="flex-end">
                                                            <Box onClick={molaKaydet} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                                <Box mr="5px" justifyContent="center"><i className="text-white fa fa-check" /></Box>
                                                                <Box justifyContent="center"><span style={{ fontWeight: 600 }} className="text-white">{molaGuncellenen ? 'Güncelle' : 'Ekle'}</span></Box>
                                                            </Box>
                                                        </Box>
                                                    </div>
                                                </div>
                                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                                            </React.Fragment>
                                        )
                                    }

                                    <Box className={molaFormu ? "mt-5" : ""} flexDirection="row">
                                        <Box onClick={molaEkleIptal} className={"actionIcon p-2 " + (!molaFormu ? "bg-success" : "")} opacity={"1"} bg={molaFormu ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center"><i className={"text-white fa " + (!molaFormu ? 'fa-plus' : 'fa-times')} /></Box>
                                            <Box justifyContent="center"><span style={{ fontWeight: 600 }} className="text-white">{!molaFormu ? 'Ekle' : 'İptal Et'}</span></Box>
                                        </Box>
                                        <Box onClick={molaSeciliSayisi == 1 ? molaGuncelleAc : undefined} opacity={molaSeciliSayisi == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center"><i className="text-white fa fa-edit" /></Box>
                                            <Box justifyContent="center"><span style={{ fontWeight: 600 }} className="text-white">Güncelle</span></Box>
                                        </Box>
                                        <Box onClick={molaSeciliSayisi > 0 ? molaSil : undefined} opacity={molaSeciliSayisi > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center"><i className="text-white fa fa-trash" /></Box>
                                            <Box justifyContent="center"><span style={{ fontWeight: 600 }} className="text-white">Sil</span></Box>
                                        </Box>
                                    </Box>

                                    <div className='table-responsive mt-5'>
                                        <table className='table align-middle table-row-dashed dataTable no-footer'>
                                            <thead>
                                                <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                    <th style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={molaTumunuSec} className='form-check-input' type='checkbox' checked={molaSeciliSayisi > 0 && molaSeciliSayisi == molalar.length} />
                                                            </label>
                                                        </div>
                                                    </th>
                                                    <th>Ad</th>
                                                    <th>Başlangıç</th>
                                                    <th>Bitiş</th>
                                                </tr>
                                            </thead>
                                            <tbody className='text-gray-600 fw-bold'>
                                                {molalar.length == 0 && <tr><td className="text-center" colSpan={99}>Ara / mola yok.</td></tr>}
                                                {
                                                    molalar.map(m =>
                                                        <tr key={m.anahtar} onClick={() => molaSecimi(m.anahtar)} style={{ cursor: 'pointer', background: m.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                            <td style={{ width: 1 }}>
                                                                <div className='d-flex'>
                                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                        <input onChange={() => molaSecimi(m.anahtar)} onClick={(e) => e.stopPropagation()} className='form-check-input' type='checkbox' checked={m.isSelected} />
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td className="text-gray-800">{m.ad}</td>
                                                            <td>{m.baslangic}</td>
                                                            <td>{m.bitis}</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>

                                    {
                                        onizleme && (
                                            <div className="fs-7 mt-5">
                                                Çalışma süresi <b>{saatMetni(onizleme.dk)}</b>
                                                {onizleme.gece && ' · bitiş ertesi gün (kayıt başladığı güne yazılır)'}
                                            </div>
                                        )
                                    }

                                    <div className="text-muted fs-7 mt-2">
                                        Vardiyalı personelde bu saatler normal süredir; bitişten sonrası ek mesai. Ara ve molalar (en çok {MOLA_EN_FAZLA}) normal süreden düşer (yalnız kişinin içeride olduğu kısım); gece vardiyasında gece yarısından sonraki mola ertesi güne sayılır. Hafta tatili için ayrı vardiya tanımlanmaz, planda HT yazılır.
                                        {' '}Bildirim ve tekrar boşsa Çalışma Saatleri'ndeki değer kullanılır. Planda kullanılan vardiya silinemez; pasif yapılabilir.
                                    </div>

                                    <Box flexDirection="row" justifyContent="flex-end" className="mt-5">
                                        <Box mr="15px">
                                            <button className="btn btn-sm btn-light btn-active-light-primary" onClick={iptalEt}>İptal Et</button>
                                        </Box>
                                        <Box>
                                            <button className="btn btn-primary btn-sm" onClick={kaydet}>Kaydet</button>
                                        </Box>
                                    </Box>
                                </KTCardBody>
                            </KTCard>
                        </div>
                    )
                }

                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips columns={columns} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={gorunen.length > 0 && gorunen.every(x => x.isSelected)} />
                                                </label>
                                            </div>
                                        </th>
                                        {gorunenKolonlar.map(item => <th key={item.name} {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>)}
                                    </tr>
                                    <ColumnFilterRow columns={gorunenKolonlar} definitions={columnFilterDefinitions} filters={filter.columnFilters} onChange={changeColumnFilters} leadingCellCount={1} />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        gorunen.length == 0 && (
                                            <tr><td className="text-center" colSpan={99}>Kayıt bulunamadı. Önce vardiyaları (Sabah, Akşam, Gece ...) tanımlayın.</td></tr>
                                        )
                                    }
                                    {
                                        gorunen.map(item =>
                                            <tr key={item.vardiyaTanimiId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.vardiyaTanimiId)} className='form-check-input' type='checkbox' checked={item.isSelected ?? false} />
                                                        </label>
                                                    </div>
                                                </td>
                                                {gorunenKolonlar.map(c => hucre(item, c.name))}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="text-muted fs-7 py-3">
                            {gorunen.length} kayıt · İş Kanunu: gece çalışması (20:00–06:00) en çok 7,5 saat; iki vardiya arasında en az 11 saat dinlenme.
                        </div>
                    </KTCardBody>
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default VardiyaTanimiList;
